import './collection-banner.css';

export default (element, data) => {};
